/**
* @copyright
* Copyright(c) 2018 SICK AG
*/

const style = `
:host {
  display: none;
}

:host([open]) {
  display: block;
}
`;
export { style };
